module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAYAAADhu0ooAAAAAXNSR0IArs4c6QAAALxJREFUaEPtmjEOgCAQBI+H8joeqrGwIRBqZsfGRBv35m5XAm2M8VRV9d7bd58vyvtGEXICtaS4Inv7M4XeTnD+foniiMa4boxQWovu9GhGNNISxRGNcd0YobQWNV4kCqtATo7GuG6MUNgobuXkzKhEYRXIad0Y140RChtF4yXHjGxdWAVydryNF1rrwvSYo+YoraWNl58oJX6cUdyM0gS5mxZDlOKqx/O6MUJjWlehsAr4ZwQDWq5eaKuXF+BwLKk87vBTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gift.png
// module id = XOn5
// module chunks = 1